const HTMLTableRow = (props) => {
	return <tr {...props} />;
};

export default HTMLTableRow;
